


















































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import axios from 'axios'
import { Toast } from 'vant'
const instance = axios.create({
  // headers: {'X-Custom-Header': 'foobar'}
})
import rtSelect from '@/components/estate/selectCom.vue'

const estateModule = namespace('estate')

@Component({
  components: {
    rtSelect
  }
})
export default class Form extends Vue {
  @estateModule.State('repairTypeList') repairTypeList!: any
  businessPoiInfo: any = {}
  floorList: any = []
  name: string = ''
  message: string = ''
  fileList: any = []
  floorType: any = ''
  floorName: string = ''
  repairType: any = ''
  repairName: string = ''
  mounted() {
    this.getRepairTypeList()
    this.getEstateFloorList()
  }
  get action() {
    return this.$http['FILE_UPLOAD'].api
  }
  /**获取楼层列表 */
  getEstateFloorList() {
    let uBusinessEntity: any = this.$global.uBusinessEntity
    if (uBusinessEntity) {
      this.businessPoiInfo = uBusinessEntity.businessPoiInfo
        ? uBusinessEntity.businessPoiInfo
        : {}
      console.log(uBusinessEntity)
      uBusinessEntity.floorList = uBusinessEntity.floorList
        ? uBusinessEntity.floorList.map((val: any) => {
            val.name = val.lbsFloorName
            val.value = val.lbsFloorId
              ? val.lbsFloorId
              : val.lbsFloorThirdPartyId
            return val
          })
        : []
      this.floorList = uBusinessEntity.floorList
      console.log('建筑物', this.businessPoiInfo)
      console.log('楼层', this.floorList)
    }
  }
  /**获取报修类型列表 */
  async getRepairTypeList() {
    const { success } = await this.$store.dispatch(
      'estate/getEstateRepairList',
      {}
    )
    if (success) {
      console.log('报修类型列表', this.repairTypeList)
    }
  }

  handleSumChange() {}

  uploadfiles(val: any, index: any) {
    //图文图片上传
    const param = new FormData()
    param.append('file', val.file)
    instance
      .post(this.action, param, {
        headers: {
          'Content-Type': 'multipart/form-data',
          token: this.$global.token,
          tenantId: this.$global.tenantId,
          tenantType: this.$global.tenantType
        }
      })
      .then(res => {
        if (res.data.status == 200) {
          if (res.data.data.path) {
            this.fileList.push({ url: res.data.data.path })
          }
        } else {
          Toast(res.data.message)
        }
      })
  }
  del(url: any) {
    let index = this.fileList.indexOf(url)
    this.fileList.splice(index, 1)
  }
  handleSelectFloorClick(item: any) {
    this.floorType = item.value
    this.floorName = item.name
  }
  handleSelectRepairClick(item: any) {
    this.repairType = item.value
    this.repairName = item.name
  }
  /**创建 */
  handleCreateClick() {
    let urls: any = []
    this.fileList &&
      this.fileList.map((val: any) => {
        urls.push(val.url)
      })
    let par = {
      buildingId: this.businessPoiInfo.lbsBuildingThirdPartyId
        ? this.businessPoiInfo.lbsBuildingThirdPartyId
        : this.$global.tenantId,
      buildingName: this.businessPoiInfo.lbsBuildingName
        ? this.businessPoiInfo.lbsBuildingName
        : this.$global.tenantName,
      detail: this.message,
      floorId: this.floorType ? this.floorType : 'F0',
      floorName: this.floorName ? this.floorType : 'F0',
      parentTenantId: this.$global.parentBusinessEntityId
        ? Number(this.$global.parentBusinessEntityId)
        : Number(this.$global.tenantId),
      parentTenantType: this.$global.parentBusinessEntityTypeId
        ? Number(this.$global.parentBusinessEntityTypeId)
        : Number(this.$global.tenantType),
      title: this.name,
      type: this.repairType,
      typeName: this.repairName,
      urls: urls
    }
    if (par.title == '' || !par.title) {
      Toast('请输入报修标题')
      return
    }
    if (par.floorId == '' || !par.floorId) {
      Toast('请选择所属楼层')
      return
    }
    if (par.type == '' || !par.type) {
      Toast('请选择报修类型')
      return
    }
    if (par.detail == '' || !par.detail) {
      Toast('请输入报修内容')
      return
    }
    if (par.urls && par.urls.length < 1) {
      Toast('请上传照片')
      return
    }
    this.addEstate(par)
  }
  async addEstate(par: any) {
    const { error, success }: any = await this.$store.dispatch(
      'estate/estateMaintainAdd',
      par
    )
    if (success) {
      Toast('创建成功')
      this.$router.push('/estate')
    }
    if (error) {
      Toast(error.msg)
    }
  }
}
